import {
  Box,
  Button, Grid,
  Group,
  Modal,
  MultiSelect,
  Paper,
  Popover,
  ScrollArea,
  Select,
  Stack,
  Switch,
  Text,
  Title,
  Textarea,
  Image,
  SimpleGrid,
  Skeleton,
  Badge,
  useMantineTheme
} from "@mantine/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { logger } from "utils/logger";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { getClientLabel, getStatusColor, handleZipDownload, pluralize } from "utils/helper";

import {
  CheckboxDropdown,
  Crumbline,
  FilterButton, FormInputWrapper
} from "../../../../core/components";
import {
  CaptureNoteEditor,
  NoteEditorState,
} from "../../../../core/components/capture/CaptureNoteEditor";

import { SampleStatusTypes } from "core/models/SampleModel";
import { useAbortController } from "core/hooks/useAbortableController";
import { ListViewOption } from "core/components/listToggle/listToggleControl";
import {
  IconAdjustmentsHorizontal,
  IconCameraCheck,
  IconCheck,
  IconClearAll,
  IconDownload,
  IconNote,
} from "@tabler/icons-react";
import { isDate } from "moment";
import CustomDatePicker from "core/components/datePicker/CustomDatePicker";
import styles from "../style/Style.module.scss";

import { CaptureEventType } from "core/components/capture/CaptureThumb";
import { AppConstants, MarkupEventTypes, StudioStatusTypes } from "utils/constants";
import { useLocalStorage } from "@mantine/hooks";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import {
  selectStyle,
  setSessionCaptures,

  updateStudioSession
} from "modules/Wip/wipSlice";

import {
  fetchMarkups,
  fetchPostProductionTasks,
  fetchTaskMeta,
  getTaskSuccess,
  setMarkup,
  setTaskItemFilter,
  updatePostProductionTask,
} from "modules/Approval/approvalSlice";



import { selectItems } from "utils/helper";
import _ from "lodash";
import AssetViewer from "core/components/approval/AssetViewer";
import CaptureFilterPanel from "core/components/capture/CaptureFilterPanel";
import { MediaFilterModel } from "core/models";
import TaskMediaList from "./TaskMediaList";

const Task = ({
  user,
  task,
  taskItemFilter,
  setTaskItemFilter,
  setStyleFilter,
  success,
  error,
  postProductionWipList,
}) => {
  const dispatch = useDispatch();
  // const { classes } = useStyles();
  const [listView, setListView] = useState(ListViewOption.LIST);
  const [approvalType, setApprovalType] = useState(null);

  const params = useParams();
  const [activeTab, setActiveTab] = useState("styles");
  const navigate = useNavigate();
  const hasInit = useRef(false);
  const abortController = useAbortController();
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [wipData, setWipData] = useState([]);
  const [filterItems, setFilterItems] = useState(taskItemFilter);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [selectedItems, setSelectedItems] = useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [completionNotes, setCompletionNotes] = useState("");

  const theme = useMantineTheme();
  const [displaySettings, setDisplaySettings] = useLocalStorage({
    key: "op-task-display-settings",
    defaultValue: {
      imageFit: "cover",
      showMeta: true,
      imageSize: "300",
    },
  });

  useEffect(() => {
    logger.log(success);
    if (success) {
      switch (success.type) {
        case getTaskSuccess.toString(): {
          setIsLoading(false);

          dispatch(fetchMarkups(task.id, {part: task.taskPart, sort: task.taskSort}, user));
          break;
        }
      }
    }
  }, [success]);

  // get the style from the url
  useEffect(() => {
    logger.log(params);

    // if the task and params match
    if(task && task.taskSort === params.taskSort && hasInit.current === false) {
      hasInit.current = true;
      setIsLoading(false);
      dispatch(fetchMarkups(task.id, {part: task.taskPart, sort: task.taskSort}, user));
      return;
    }
    else if (
      params &&
      params.taskSort &&
      (!task || (task && task.taskSort !== params.taskSort)) &&
      params.taskSort &&
      !hasInit.current
    ) {
      hasInit.current = true;
      // fetch the styles
      dispatch(fetchTaskMeta(params.taskPart, params.taskSort));

      // fetch the post production tasks
      dispatch(fetchPostProductionTasks({}));
    } else if (!hasInit.current) {
      hasInit.current = true;

      dispatch(fetchTaskMeta(params.taskPart, params.taskSort));
    }
  }, [params]);

  const form = useForm({
    initialValues: {
      ...task,
      name: "",
      deadline: new Date(2021, 11, 5),
    },

    validate: {
      // email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
    },
  });

  useEffect(() => {
    const deadline = task && task.deadline ? new Date(task.deadline) : "";
    form.setValues({ ...task, deadline: deadline });
  }, [task]);

  const onFormSubmit = (vals) => {
    logger.log("Submitting form");
    const data = {
      id: task.id,
      code: form.values.code,
      name: form.values.name,
      description: form.values.description,
      deadline: form.values.deadline,
      tags: form.values.tags.join(","),
      // team:form.values.team,
      // ts:form.values.ts,
    };
    // dispatch(updateSeason(data, user));
  };

  const crumbItems = [
    { title: "Approvals", route: "/approval", search: "" },
    { title: "Post Production", route: "/approval/postproduction", search: "" },
    {
      title: params.taskSort ?? "",
      route: `approval/postproduction/${params.taskSort}`,
    },
  ];

  /**
   * Effect to handle location change
   */

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let displayType = params.get("displayType");

    const path = location.pathname;
    const type = path.split("/")[2];
    if (type && type !== approvalType) setApprovalType(type);

    logger.log(
      "location change ",
      location,
      " DISPLAY: ",
      displayType,
      params,
      listView
    );
    // if display type changes
    if (displayType && displayType !== listView) setListView(displayType);
  }, [location]);

  const onStatusClick = (type, data) => {
    switch (type) {
      // if they have clicked on the photography count then we want to filter
      // the media based on the style code
      // case SampleStatusTypes.SAMPLE_PHOTOGRAPHY_COUNT:{
      //     const filter = {...mediaFilter,styles:[data.stylenumber]};
      //     setMediaFilter(filter);

      //     // nav to the media tab
      //     onTabChange('media');
      //     break;
      // }
      // case SampleStatusTypes.SAMPLE_TASK_COUNT:{
      //     const filter = {...taskFilter,styles:[data.stylenumber]};
      //     setTaskFilter(filter);

      //     // nav to the media tab
      //     onTabChange('tasks');
      //     break;
      // }
      case SampleStatusTypes.SAMPLE_SCAN_COUNT: {
        // take them too the scan
        navigate(`/warehouse/scans/${data.scan.gid}`);
        logger.log(data);
        break;
      }
      default: {
        break;
      }
    }
  };

  const setFilterVars = (vals) => {
    logger.log(vals);
    setTaskItemFilter(vals);
  };
  const filterWips = useCallback(() => {
    // var data = filterSamples(wips, taskItemFilter);
    // setWipData(data);
  }, [
    // taskItemFilter.brands,
    taskItemFilter.categories,
    setWipData,
    taskItemFilter.groupBy,
    taskItemFilter.keyword,
  ]);

  useEffect(() => {
    //setWipData(wips);

    // set the brands/season/category
    // var styleNumbers = {};
    // var sessions = {};
    // var seasons = {};
    // var statuses = {};
    // var talents = {};
    var tags = {};
    // var depts = {};
    // var sizes = {};

    // wips?.forEach((item, idx) => {
    //   styleNumbers[item.ssSort] = item;
    //   sessions[item.sessionCode] = item;
    //   seasons[item.seasonCode] = item;
    //   // statuses[item.status] = item;
    //   talents[item.talentNames] = item;
    //   issuers[item.issuer] = item;
    //   depts[item.dept] = item;
    //   sizes[item.size] = item;
    // });
    task?.items?.forEach((item, idx) => {
      // item.tags is a string split it by comma and then add it to the tags object
      item.tags?.split(",").forEach((tag, idx) => {
        tags[tag.trim()] = item;
      });
      // tags[item.tags] = item;
    });

    setFilterItems({
      tags,
    });

    // setFilterItems({
    //   styleNumbers,
    //   sessions,
    //   seasons,
    //   // statuses,
    //   talents,
    //   depts,
    //   issuers,
    //   sizes,
    // });

    filterWips();
  }, [filterWips, task]);

  logger.log(task);

  const getFilterCount = (val) => {
    var count = 0;

    const dateKeys = ["otbDate", "distribution", "completed"];
    const ignoreKeys = ["groupBy", "starComparison", "sessionId"];

    Object.entries(val).forEach(([key, value]) => {
      if (value && value.length && ignoreKeys.indexOf(key) === -1) {
        ++count;
      }

      if (key === "status") {
        var statusCount = 0;
        Object.entries(value).forEach(([key, value]) => {
          if (value.length) {
            statusCount = 1;
          }
        });

        count += statusCount;
      }

      if (dateKeys.indexOf(key) > -1) {
        if (isDate(value.dateStart) || isDate(value.dateEnd)) {
          ++count;
        }
      }
    });

    return count;
  };

  useEffect(() => {
    const count = getFilterCount(taskItemFilter);
    setFilterCount(count);
  }, [taskItemFilter]);

  const onClearClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();

    setTaskItemFilter({
      ...new MediaFilterModel({ groupBy: taskItemFilter.groupBy, hasAnnotations: -1 }),
    });

    // setWipFilter({ ...new SampleFilterModel({ groupBy: taskItemFilter.groupBy }) });

    logger.log("CLEAR CLICK", e);
  };

  /**
   * Handles the list toggle display
   * @param {*} val
   */
  const listToggleHandler = (val) => {
    navigate({ search: `?displayType=${val}` });
  };

  const filterButtonHandler = (e) => {
    logger.log("BUTTON CLICK", e, e.nativeEvent);
    setFilterOpen((o) => !o);
  };

  /**
   * Handler for when a capture is selected.
   * @param {*} item
   * @param {*} selected
   */
  const onItemSelected = (e, item, selected) => {
    var items = [...selectedItems];

    // Use wipData as the page items since that represents the current filtered data
    const pageItems = task?.items?.map((val) => {
      // Handle both flat data and grouped data structure
      return val.original ? { ...val.original } : { ...val };
    });

    if (item.type && item.type === "group") {
      // select all the sub items.
      let subItems = [...item.subRows];
      if (selected) {
        subItems.forEach((val) => {
          selectItems(e, val, selected, pageItems, items);
        });
      } else {
        items = _.differenceBy(items, subItems, "id");
      }
    } else {
      // call general helper to select items
      selectItems(e, item, selected, pageItems, items);
    }

    setSelectedItems(items);
    //dispatch(selectTasks(items));
    //selectTask(items);
  };

  const onMediaAction = (e, val, originalEvent, items) => {
    logger.log(e);
    switch (e) {
      case CaptureEventType.IMAGE_CLICK: {
        setSelectedAsset(val);
        setImageModalOpen(true);
        break;
      }
      case CaptureEventType.SELECT_CLICK: {
        // setSelectedItems(items);
        const selected = !selectedItems.find((item) => item.id === val.id);
        onItemSelected(originalEvent, val, selected);
        break;
      }
      default: {
        break;
      }
    }
    logger.log(e, val, items);
  };

  const onChange = (vals) => {
    setDisplaySettings(vals);
  };

  const onMarkupChange = (type, data) => {
    logger.log(type, data);
    const {image, payload} = data;
    switch (type) {
      case MarkupEventTypes.UPDATE_MARKUP: {
        logger.log(' updating markup', data);

        // {
        //   "annPart": "TASK_Session#TAR-12345__178221782217822",
        //   "annSort": "1677800766921",
        //   "payload": "{your json here..snip}",
        //   "ts": "1677800766921",
        //    "item": "3",
        //   "comment":"remove this blemish", <-- or maybe the comment is in the payload json? Up to you.
        //   "user": "ben@huntergatherer.io"
        //  }
        // ts as a number (timestamp in milliseconds)
        const ts = Date.now();
        let markupData
        if(!payload.payload){
          logger.log(' no payload', payload);
          markupData = payload;
        }else{
          markupData = payload.payload;
        }
       
        // get the item index in the task.assets array
        const itemIndex = task.items.findIndex((item) => item.id === image.id);
        const model = {
          annPart: task.taskPart,
          annSort: task.taskSort,
          markup: markupData,
          sequence: itemIndex,
          user: `${user.first} ${user.last}`,
          ts: ts,
          id:markupData.id,
        }
        //  const markup = {
        //   annPart: `${task.taskPart}`,
        //   annSort: task.taskSort,
        //   markup: payload,
        //   sequence: itemIndex,
        //   item: image.id,
        //   user: user.email,
        //   id: data.id??payload.payload.id,
        // }

        // var markup = {...payload, sequence: itemIndex, id:data.id??payload.markup.id};

        logger.log(model, "markup");
        dispatch(setMarkup(image,model,user));
        break;
      }
      case MarkupEventTypes.DELETE_MARKUP: {
        logger.log(' deleting markup', data);
        break;
      }
      case MarkupEventTypes.ADD_MARKUP: {
        logger.log(' adding markup', data);
      //   const itemIndex = task.items.findIndex((item) => item.id === image.id);
      //   const markup = {
      //    annPart: `${task.taskPart}`,
      //    annSort: task.taskSort,
      //    markup: payload,
      //    sequence: itemIndex,
      //    item: image.id,
      //    user: user.email,
      //    id: null // new markup, so no id yet,
      //  }
      //  dispatch(setMarkup(image,markup,user));
        break;
      }
    }
  };

  const onCaptureChange = (type, data, items) => {
    logger.log(type, data, items);
    switch (type) {
      case CaptureEventType.RATING_CHANGE: {
        const tmpItems = items.map((val) => {
          return {
            star: data.data.toString(),
            actionPart: val.actionPart,
            actionSort: val.actionSort,
          };
        });
        dispatch(setSessionCaptures(tmpItems, user));
        break;
      }
      case CaptureEventType.STATUS_CHANGE: {
        const tmpItems = items.map((val) => {
          return {
            sak: data.data.toString(),
            actionPart: val.actionPart,
            actionSort: val.actionSort,
          };
        });
        dispatch(setSessionCaptures(tmpItems, user));
        break;
      }
      case CaptureEventType.NOTES_CHANGE: {
        const tmpItems = items.map((val) => {
          return {
            clientNotes: data.data.toString(),
            actionPart: val.actionPart,
            actionSort: val.actionSort,
          };
        });
        dispatch(setSessionCaptures(tmpItems, user));
        break;
      }
      case CaptureEventType.DOWNLOAD: {
        // find all the items
        const extension = data.type && data.type === "eipURL" ? "eip" : "png";
        handleZipDownload(
          items,
          "originalFilename",
          task.styleNumber,
          data.type,
          extension
        );
        break;
      }
      case CaptureEventType.SHOW_BATCH_NOTES_EDITOR: {
        // find all the items
        // open modal with the notes editor
        modals.open({
          title: "Batch Update Approval Notes",
          size: "md",
          children: (
            <Stack>
              <Text size="sm" c="dimmed">
                Enter the notes below to update the notes for the (
                {items?.length}) selected items
              </Text>
              <CaptureNoteEditor
                defaultState={NoteEditorState.EDITING}
                notes={selectedItems[0]?.clientNotes || ""}
                onNotesChange={(newNotes) => {
                  // Handle notes change by calling the existing onCaptureChange function
                  onCaptureChange(
                    CaptureEventType.NOTES_CHANGE,
                    { data: newNotes },
                    selectedItems
                  );
                  modals.closeAll();
                }}
              />
            </Stack>
          ),
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  const onSelectAll = () => {
    setSelectedItems(
      selectedItems.length === task?.items?.length ? [] : task?.items
    );
  };

  /**
   * Handler for the Capture menu events.
   * @param {*} e
   * @param {*} data
   * @param {*} items
   */
  const onMenuItemClick = (e, data, items) => {
    logger.log(e);
    var captures = [];
    switch (e) {
      case CaptureEventType.DOWNLOAD: {
        // find all the items
        const arr = items.map((val) => {
          const item = task?.items?.find((session) => val.id === session.id);
          if (item) return item;
        });
        const extension = data.type && data.type === "eipURL" ? "eip" : "png";
        handleZipDownload(
          arr,
          "originalFilename",
          task.id,
          data.type,
          extension
        );
        break;
      }
      case CaptureEventType.COLOUR_CHANGE:
      case CaptureEventType.RATING_CHANGE:
      case CaptureEventType.STATUS_CHANGE: {
        captures = items.map((val) => {
          return task?.items?.find((obj) => obj.id === val.id);
        });

        onCaptureChange(e, data, captures);
        break;
      }
      case CaptureEventType.BATCH_CREATE_TASK:
      case CaptureEventType.APPLY_STYLE_INFO:
      case CaptureEventType.CREATE_TASK: {
        captures = items.map((val) => {
          return task?.items?.find((obj) => obj.id === val.id);
        });

        onMediaAction(e, data, captures);
        break;
      }
      case CaptureEventType.MARK_COMPLETED: {
        captures = items.map((val) => {
          return task.items.find((obj) => obj.id === val.id);
        });
       
        dispatch(updatePostProductionTask(data, user));
        // dispatch(updateStudioSession(data, user));
        break;
      }
      case CaptureEventType.SHOW_BATCH_NOTES_EDITOR: {
        // open modal with the notes editor
        onCaptureChange(e, data, items);
        break;
      }
      // case CaptureEventType.TAG_TALENT: {
      //   setShowTagTalent(true);
      //   break;
      // }
      default: {
        break;
      }
    }
  };

  const selectAllMenu = (
    <div>
      <Button
        variant="default"
        className={"select-all-menu-button"}
        leftSection={<IconDownload size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.DOWNLOAD,
            { data: null, type: "postProductionPreview" },
            selectedItems
          )
        }
      >
        Download {pluralize("Image", selectedItems.length)}
      </Button>

      {/* <Button variant='default' leftIcon={<IconDownload size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.DOWNLOAD, { data: null, type: 'eipURL' }, selectedItems)}>
            Download EIP
        </Button> */}
      {/* <Button
        variant="default"
        className={"select-all-menu-button"}
        leftSection={<IconNote size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.SHOW_BATCH_NOTES_EDITOR,
            { data: null },
            selectedItems
          )
        }
      >
        Batch Update Notes
      </Button> */}

      <Button
        variant="default"
        className={"select-all-menu-button"}
        leftSection={<IconClearAll size={14} />}
        onClick={(e) => setSelectedItems([])}
      >
        Deselect All
      </Button>
      {/* <Button variant='default' leftIcon={<IconSubtask size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.CREATE_TASK, { data: null }, selectedItems)}>
            Create Task
        </Button> */}
      {/* <Button variant='default' leftIcon={<IconColorSwatch size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.APPLY_STYLE_INFO, { data: null }, selectedItems)}>
            Apply Styles
        </Button>

        <Button variant='default' leftIcon={<IconUserCheck size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.TAG_TALENT, { data: null }, selectedItems)}>
            Tag Talent
        </Button> */}

      {/* <Button variant='default' leftIcon={<IconArchive size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.ARCHIVE, { data: null }, selectedItems)}>
            Archive Assets
        </Button> */}

      {/* {mediaFilter.groupBy === "styles" ? (
        <Button
          variant="default"
          leftIcon={<IconChecklist size={14} />}
          onClick={(e) =>
            onMenuItemClick(
              CaptureEventType.BATCH_CREATE_TASK,
              { data: null },
              selectedItems
            )
          }
        >
          Batch Create Tasks
        </Button>
      ) : null} */}

      {/* <Divider mt={"sm"} /> */}
      {/* <Group>
  <Title order={6} color={'dimmed'}>Rating</Title>
  <Divider />
</Group> */}
      {/* <Group px={"xs"}>
        <FormInputWrapper
          label="Rate"
          id="input-rating"
          labelWidth={80}
          style={{
            marginTop: 12,
            marginBottom: 0,
            ".mantine-Text-root": { marginTop: 0, marginBottom: 0 },
          }}
        >
          <div style={{ marginTop: 4 }}>
            <StarRating
              size={"sm"}
              onChange={(val) =>
                onMenuItemClick(
                  CaptureEventType.RATING_CHANGE,
                  { data: val },
                  selectedItems
                )
              }
            />
          </div>
        </FormInputWrapper>
      </Group> */}

      {/* <Group px={"xs"}>
        <FormInputWrapper
          label="Flag"
          id="input-rating"
          labelWidth={80}
          style={{ marginTop: 4, marginBottom: 0 }}
        >
          <div style={{ marginTop: 4 }}>
            <FlagToggle
              size={"sm"}
              onChange={(val) =>
                onMenuItemClick(
                  CaptureEventType.STATUS_CHANGE,
                  { data: val },
                  selectedItems
                )
              }
            />
          </div>
        </FormInputWrapper>
      </Group> */}

      {/* <Group px={'xs'}>
            <FormInputWrapper label='Colour Tag' id='input-colourTag' labelWidth={80} style={{ marginTop: 4, marginBottom: 0 }}>
                <div style={{ marginTop: 4 }}>
                    <ColourTag layout='inline' size={'sm'} color={''} onColourChange={(val) => onMenuItemClick(CaptureEventType.COLOUR_CHANGE, { data: val }, selectedItems)} />
                </div>
            </FormInputWrapper>
        </Group> */}
    </div>
  );
  logger.log(task, "STYLE", selectedAsset);

  const onImageEvent = (type, data, originalEvent) => {
    logger.log(type, data, originalEvent);
    switch (type) {
      case CaptureEventType.IMAGE_CLICK: {
        // fetch the markups
        // dispatch(fetchMarkups(data.id, {part: task.taskPart, sort: task.taskSort}, user));
        break;
      }
    }
  };
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Group className="main-container-header">
        <Group position="apart" sx={{ width: "100%" }}>
          <Crumbline items={crumbItems}></Crumbline>
          {/* <Button>Update Season</Button> */}
        </Group>
      </Group>
      <Group
        className="main-container-header"
        justify="space-between"
        align="center"
      >
        <Group style={{ width: "100%" }} justify="space-between">
          {isLoading ? (
            <Group>
              <Skeleton height={30} width={300} />
              <Skeleton height={30} width={50} />
            </Group>
          ) : (
            <Group>
              <Title order={3} lh={"lg"}>
                {task?.description}
              </Title>
              {task?.department ? <PrimaryBadge>{task?.department}</PrimaryBadge> : null}
              <Badge
                variant="light"
                color={getStatusColor(task?.status)}
              >
                {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
                {StudioStatusTypes[task?.status?.toUpperCase()].label}
                {/* {task?.status} */}
                {/* </Moment> */}
              </Badge>
            </Group>
          )}

          <Group>
            <Popover width={300} position="bottom" withArrow shadow="md">
              <Popover.Target>
                <Button
                  leftSection={
                    <IconAdjustmentsHorizontal
                      size={AppConstants.ICON_SIZE}
                      stroke={AppConstants.ICON_STROKE_WIDTH}
                    />
                  }
                  variant="default"
                >
                  Display Settings
                </Button>
              </Popover.Target>
              <Popover.Dropdown>
                <Paper p="md" radius="sm">
                  <Stack spacing="md">
                    <Select
                      label="Image Fit"
                      description="How the image should fit within its container"
                      data={imageFitOptions}
                      value={displaySettings.imageFit}
                      comboboxProps={{ withinPortal: false }}
                      onChange={(value) =>
                        onChange({ ...displaySettings, imageFit: value })
                      }
                    />

                    <Select
                      label="Size"
                      description="How the image should fit within its container"
                      data={imageSizeOptions}
                      value={displaySettings.imageSize}
                      comboboxProps={{ withinPortal: false }}
                      onChange={(value) =>
                        onChange({ ...displaySettings, imageSize: value })
                      }
                    />

                    <Switch
                      label="Show Meta Information"
                      description="Display additional image metadata"
                      checked={displaySettings.showMeta}
                      onChange={(event) =>
                        onChange({
                          ...displaySettings,
                          showMeta: event.currentTarget.checked,
                        })
                      }
                    />
                  </Stack>
                </Paper>
              </Popover.Dropdown>
            </Popover>

            {/* <Button
              variant="outline"
              leftSection={<IconCheck size={14} />}
              onClick={() => setConfirmationModalOpen(true)}
              disabled={selectedItems.length === 0}
            >
              Mark as Reviewed
            </Button> */}
          </Group>
        </Group>
        {/* <ListToggleControl
          value={listView}
          onChange={(val) => listToggleHandler(val)}
        /> */}
      </Group>
      <Group
        className="container-action-bar"
        style={{ width: "100%" }}
        justify="space-between"
        height={"100%"}
        py="xs"
      >
        <Group>
          <CheckboxDropdown
            selectedItems={selectedItems}
            onCheckboxClick={onSelectAll}
            selectMenu={selectAllMenu}
          />
          <Text order={6} size="sm" my={"xs"}>
            Displaying {task?.items?.length} Assets
          </Text>
        </Group>

        <Group>
          <Popover
            shadow="sm"
            opened={filterOpen}
            onChange={setFilterOpen}
            width={500}
            withArrow
            closeOnClickOutside={true}
            closeOnEscape={true}
            trapFocus={false}
            position="bottom-end"
            clickOutsideEvents={["mousedown", "touchstart"]}

            // onClose={() => setFilterOpen(false)}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div style={{ display: "flex" }}>
                <CaptureFilterPanel
                  filter={taskItemFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                  styleCodes={[]}
                  departments={[]}
                  filterFields={[                    
                    {
                      label: "Annotations",
                      value: "hasAnnotations",
                    },
                  ]}
                />
              </div>
            </Popover.Dropdown>
          </Popover>
        </Group>
        {/* <Group>
          <CheckboxDropdown selectedItems={selectedWips} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} />
          <Input
            leftSection={<IconSearch />}
            style={{ width: 250 }}
            value={taskItemFilter.keyword}
            onChange={(e) =>
              setStyleFilter({
                ...taskItemFilter,
                keyword: e.currentTarget.value,
              })
            }
            // placeholder="Filter assets"
            placeholder={`Search across ${wips.length} ${pluralize('Record',wips.length)}`}
            rightSectionPointerEvents="all"
            rightSection={
              <ActionIcon
                variant="transparent"
                onClick={() =>
                  setStyleFilter({
                    ...taskItemFilter,
                    keyword: "",
                  })
                }
              >
                {taskItemFilter.keyword.length ? <IconX size={14} /> : null}
              </ActionIcon>
            }
          />
        </Group>
        <Group>
          <Popover
            shadow="sm"
            opened={filterOpen}
            onChange={setFilterOpen}
            width={610}
            withArrow
            closeOnClickOutside={true}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div wip={{ display: "flex" }}>
                <FilterPanel
                  filter={taskItemFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                />
              </div>
            </Popover.Dropdown>
          </Popover>
          {listView !== ListViewOption.CALENDAR ? (
            <Select
              placeholder="Group By"
              value={taskItemFilter.groupBy}
              onChange={(val) =>
                setStyleFilter({ ...taskItemFilter, groupBy: val })
              }
              data={[
                { value: "", label: "No Group" },
                { value: "seasonCode", label: "Group by Season" },
                { value: "sessionCode", label: "Group by Session" },
                { value: "dept", label: "Group by Department" },
                { value: "status", label: "Group by Status" },
              ]}
            />
          ) : null}
        </Group> */}
      </Group>

      {/* <Group pt={"lg"} position="apart">
        <Title order={3}>{season?.name}</Title>
        <Group>
          <Menu width={200} shadow="md">
            <Menu.Target>
              <Button>Upload Spreadsheet</Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item onClick={() => onUploadClick("seasons")}>
                Upload Event Styles
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
         
        </Group>
      </Group> */}
      <Grid
        // mb="lg"
        style={{ margin: 0, height: "100%", flexGrow: 1, overflow: "auto" }}
      >
        <Grid.Col h={"100%"} span={12}>
          <div style={{ height: "100%", flex: 1 }}>
            <div style={{ height: "100%" }}>
              <TaskMediaList
                task={task}
                onMediaAction={onMediaAction}
                displaySettings={displaySettings}
                onCaptureChange={onCaptureChange}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                taskItemFilter={taskItemFilter}
                setTaskItemFilter={setTaskItemFilter}
                showLoading={isLoading}
              />
            </div>
          </div>
        </Grid.Col>

        {/* <Grid.Col></Grid.Col> */}
      </Grid>

      {/* Confirmation Modal for Completing Captures */}
      <Modal
        opened={confirmationModalOpen}
        onClose={() => {
          setConfirmationModalOpen(false);
          setCompletionNotes("");
        }}
        title="Complete Review"
        size="lg"
        centered
      >
        <Stack spacing="md">
          <Text size="sm" c="dimmed">
            You are about to mark the selected images as reviewed. Please add
            any notes below.
          </Text>

          {/* Selected Images Thumbnails */}
          <Box>
            <Text size="sm" fw={500} mb="xs">
              Assets to Approve ({task?.items?.length})
            </Text>
            <ScrollArea.Autosize>
              <SimpleGrid cols={4} spacing="xs">
                {task?.items?.slice(0, 3).map((item, index) => (
                  <Box key={item.id || index} style={{ position: "relative" }}>
                    <Image
                      src={item.postProductionThumb || item.postProductionPreview || item.src}
                      alt={`Selected image ${index + 1}`}
                      radius="sm"
                      style={{
                        aspectRatio: "1",
                        objectFit: "contain",
                        // border: '2px solid var(--mantine-color-gray-3)',
                      }}
                      fallbackSrc="data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100' height='100' fill='%23f1f3f4'/%3e%3ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999'%3eImage%3c/text%3e%3c/svg%3e"
                    />
                    {/* <Text 
                      size="xs" 
                      style={{
                        position: 'absolute',
                        bottom: 2,
                        right: 2,
                        background: 'rgba(0,0,0,0.7)',
                        color: 'white',
                        padding: '2px 4px',
                        borderRadius: '2px',
                        fontSize: '10px'
                      }}
                    >
                      {index + 1}
                    </Text> */}
                  </Box>
                ))}
                {/* Show +n indicator if there are more than 8 items */}
                {task?.items?.length > 3 && (
                  <Box style={{ position: "relative" }}>
                    <Image
                      src={
                        task?.items[3].postProductionThumb ||
                        task?.items[3].postProductionPreview ||
                        task?.items[3].src
                      }
                      alt={`Selected image ${3 + 1}`}
                      radius="sm"
                      style={{
                        aspectRatio: "1",
                        objectFit: "contain",
                        // border: '2px solid var(--mantine-color-gray-3)',
                      }}
                      fallbackSrc="data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100' height='100' fill='%23f1f3f4'/%3e%3ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999'%3eImage%3c/text%3e%3c/svg%3e"
                    />

                    <Box className={styles.extraAssets}>
                      <Text className={styles.extraAssetsText}>
                        + {task?.items?.length - 3}
                      </Text>
                    </Box>
                  </Box>
                )}
              </SimpleGrid>
            </ScrollArea.Autosize>
          </Box>

          {/* Notes Textarea */}
          <Textarea
            label="Review Notes (Optional)"
            placeholder="Add any review notes for these images..."
            value={completionNotes}
            onChange={(event) => setCompletionNotes(event.currentTarget.value)}
            autosize={true}
            minRows={6}
            maxRows={6}
            data-autofocus={true}
          />

          {/* Action Buttons */}
          <Group justify="flex-end" mt="md">
            <Button
              variant="outline"
              onClick={() => {
                setConfirmationModalOpen(false);
                setCompletionNotes("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="filled"
              leftSection={<IconCheck size={16} />}
              onClick={() => {
                // Execute the completion action
                onMenuItemClick(
                  CaptureEventType.MARK_COMPLETED,
                  {
                    notes: completionNotes,
                    clientApprovalSelection: StudioStatusTypes.COMPLETE.value,
                    taskPart: task.taskPart,
                    taskSort: task.taskSort,
                  },
                  selectedItems
                );
                // Close modal and reset state
                setConfirmationModalOpen(false);
                setCompletionNotes("");
                setSelectedItems([]);
              }}
            >
              Confirm Completion
            </Button>
          </Group>
        </Stack>
      </Modal>

      <Modal
        opened={imageModalOpen}
        p={0}
        // title={selectedItem.name}
        trapFocus={true}
        closeOnEscape={false}
        id="captureModal"
        withCloseButton={false}
        fullScreen
        onClose={() => setImageModalOpen(false)}
        styles={{
          content: { padding: 0, height: "100vh" },
        }}
      >
        {/* <CaptureDetail
          showSettings={false}
          resoloveImage={false}
          image={selectedAsset}
          src={selectedAsset?.preview}
          onImageEvent={() => logger.log("On image event")}
          onCaptureChange={() => {}}
        /> */}

        <AssetViewer
          style={{
            ...task,
            name:task?.description,
            styleNumber: task?.photoCode,
            assets: task?.items?.map((val) => ({
              ...val,
              annotations: val.annotations ? [...val.annotations] : [], // Explicitly preserve annotations
              preview: val.postProductionPreview || val.postProductionThumb,
              thumb: val.postProductionThumb,
              id:val.actionSort,
              name:val.originalFilename,
            })),
            stylePart: task?.taskPart,
            styleSort: task?.taskSort,
          }}
          index={task?.items?.findIndex(
            (val) => val.id === selectedAsset?.id
          )}
          sessions={
            postProductionWipList &&
            postProductionWipList.data &&
            postProductionWipList.data.length > 0
              ? postProductionWipList.data.map((val) => {
                  logger.log(val, "val ======", task);
                  return {
                    ...val,
                    code: val.style,
                    name: val.description,
                    isDefault: task?.id === val.id,
                  };
                })
              : null
          }
          // index={0}
          onClose={() => setImageModalOpen(false)}
          onCaptureChange={onCaptureChange}
          showSettings={false}
          approvalType={approvalType}
          onFilterChange={(vals) => {
            setFilterVars(vals);
            // the sessionId attribute name is acutally the styleNumber
            if (vals.sessionId && vals.sessionId !== task.id) {
              // onSessionChange(form.values.sessionId);
              // dispatch(fetchStyleMeta(form.values.sessionId, form.values.sessionId));
              // we need to change the url location for the new style id.
              // find the item in the wips list.
              const item = postProductionWipList.data.find(
                (val) => val.id === vals.sessionId
              );
              logger.log(item, "item");
              if (item) {
                hasInit.current = false;
                dispatch(selectStyle(item));
                navigate(`/approval/postproduction/${item.ssPart}/${item.ssSort}`);
              }
            }
          }}
          approvalFilter={taskItemFilter}
          user={user}
          onMarkupChange={onMarkupChange}
          allowCommenting={true}
          showComments={true}
          onImageEvent={onImageEvent}
        />
      </Modal>

      {/* Bottom Action Bar */}
      <Group className={styles.bottomActionBarContainer}>
        <Paper
          shadow="xl"
          radius="lg"
          p="md"
          className={styles.bottomActionBar}
        >
          <Group justify="space-between" align="center">
            <Group>
              <IconCameraCheck size={18} />
              <Text size="sm" fw={500}>
                Approve {task?.items?.length}{" "}
                {pluralize("Asset", selectedItems.length)}
              </Text>
            </Group>

            <Group>
              {/* <Button
                variant="outline"
                size="sm"
                onClick={() => setSelectedItems([])}
              >
                Cancel
              </Button> */}

              <Button
                variant="filled"
                size="sm"
                leftSection={<IconCheck size={16} />}
                disabled={task?.items?.length === 0}
                onClick={() => setConfirmationModalOpen(true)}
              >
                Mark as Reviewed
              </Button>
            </Group>
          </Group>
        </Paper>
      </Group>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    taskItemFilter: state.approvalReducer.taskItemFilter,
    task: state.approvalReducer.selectedTask,
    assets: state.approvalReducer.assets,
    success: state.approvalReducer.success,
    postProductionWipList: state.approvalReducer.postProductionWipList,
  };
};

const mapDispatch = { setTaskItemFilter, setMarkup };

export default connect(mapStateToProps, mapDispatch)(Task);

const FilterPanel = ({ onCancel, onApply, filter, filterItems, user }) => {
  const form = useForm({
    initialValues: {
      ...filter,
      // status:{
      //     sampleCount:filter.status.sampleCount.toString(),
      //     photographyCount:filter.status.photographyCount.toString(),
      //     taskCount:filter.status.taskCount.toString(),
      //     taskCompletedCount:filter.status.taskCompletedCount.toString()
      // }
    },
  });

  useEffect(() => {
    if (filter && form) {
      form.setValues({ ...filter });
    }
  }, [filter]);

  const getFilterVars = useCallback(
    (key) => {
      var res = [];
      if (filterItems[key])
        Object.keys(filterItems[key]).forEach((val) => res.push(val));
      return res.sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true })
      );
    },
    [filter, filterItems]
  );

  return (
    <Box shadow="xs" wip={{ width: "100%" }}>
      <form onSubmit={form.onSubmit((values) => onApply(values))}>
        <ScrollArea h={400} wip={{ overflowX: "hidden" }}>
          <Box>
            <FormInputWrapper label="Wip" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("wipsCodes")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("wipsCodes")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Department" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("depts")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("departments")}
              />
            </FormInputWrapper>

            <FormInputWrapper
              label="Status"
              id="input-status"
              labelWidth={"120px"}
            >
              <MultiSelect
                data={getFilterVars("statuses")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("statuses")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Events" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("seasons")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("seasons")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Sessions" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("sessions")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("sessions")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Issuers" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("issuers")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("issuers")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Talent" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("talents")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("talents")}
              />
            </FormInputWrapper>

            <FormInputWrapper
              label={getClientLabel(user.clientCode, 'otbDate')}
              id="input-otbDate"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder={`From ${getClientLabel(user.clientCode, 'otbDate')}`}
                  {...form.getInputProps("otbDate.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder={`To ${getClientLabel(user.clientCode, 'otbDate')}`}
                  {...form.getInputProps("otbDate.dateEnd")}
                />
              </Group>
            </FormInputWrapper>

            <FormInputWrapper
              label="Completed Date"
              id="input-completed"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="From Completed Date"
                  {...form.getInputProps("completed.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="To Completed Date"
                  {...form.getInputProps("completed.dateEnd")}
                />
              </Group>
            </FormInputWrapper>

            <FormInputWrapper
              label="Distribution Date"
              id="input-completed"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="From Distribution Date"
                  {...form.getInputProps("distribution.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="To Distribution Date"
                  {...form.getInputProps("distribution.dateEnd")}
                />
              </Group>
            </FormInputWrapper>
          </Box>
        </ScrollArea>

        <Group justify="space-between" mt="lg">
          <Button
            variant="subtle"
            component="button"
            size="sm"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button type="submit" size="sm">
            Apply
          </Button>
        </Group>
      </form>
    </Box>
  );
};

const imageFitOptions = [
  { value: "cover", label: "Cover" },
  { value: "contain", label: "Contain" },
];

const imageSizeOptions = [
  { value: "200", label: "Small" },
  { value: "300", label: "Medium" },
  { value: "400", label: "Large" },
  { value: "600", label: "XLarge" },
];
